var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "26px",
    viewBox: "0 0 25 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/stat",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sat",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    transform: "translate(0.661291, 1.232340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0229677,1.59177208 C17.5094928,1.59177208 17.0987129,2.10524694 17.0987129,2.51602683 C17.0987129,2.97815421 17.5608403,3.3889341 18.0229677,3.33758661 L20.487647,3.33758661 L12.7855241,10.5775822 L10.0127598,8.2669453 C9.85871737,8.06155535 9.55063245,7.95886038 9.29389502,7.95886038 C9.08850508,7.95886038 8.93446262,8.06155535 8.78042016,8.16425032 L2.92680672,13.4016939 C2.56737432,13.7097788 2.51602683,14.3259487 2.82411175,14.6340336 C3.13219666,14.993466 3.7483665,14.993466 4.05645142,14.6853811 L9.29389502,9.96141234 L12.0666593,12.2720492 C12.3747442,12.6314816 12.990914,12.6828291 13.298999,12.3233967 L21.7199867,4.41588382 L21.7199867,7.03460562 C21.7199867,7.496733 22.1307666,7.90751289 22.592894,7.90751289 C23.0550214,7.90751289 23.4658012,7.496733 23.4658012,7.03460562 L23.4658012,2.41333186 C23.4658012,1.95120448 23.0550214,1.54042459 22.592894,1.54042459 L18.0229677,1.59177208 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2334616,21.1038169 L2.36198437,21.1038169 L2.36198437,1.18099219 C2.36198437,0.513474863 1.84850951,0 1.18099219,0 C0.513474863,0 9.12114585e-16,0.513474863 9.12114585e-16,1.18099219 L9.12114585e-16,22.2848091 C9.12114585e-16,22.9523264 0.513474863,23.4658012 1.18099219,23.4658012 L22.2848091,23.4658012 C22.9523264,23.4658012 23.4658012,22.9523264 23.4658012,22.2848091 C23.4658012,21.6172917 22.9009789,21.1038169 22.2334616,21.1038169 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.36453634,
    y: 15.4042459,
    width: 2.51602683,
    height: 5.2374436
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8.06155535,
    y: 12.6828291,
    width: 2.51602683,
    height: 7.95886038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 11.7072269,
    y: 12.7341766,
    width: 2.51602683,
    height: 7.95886038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 15.4042459,
    y: 10.9370146,
    width: 2.51602683,
    height: 9.80736988
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSat);
export default __webpack_public_path__ + "static/media/sat.458a01a4e269cff26783ade0a813d5f2.svg";
export { ForwardRef as ReactComponent };